import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { MailWarning, X } from "lucide-react";

export function VerifyBanner() {
    const { user } = useAuth();
    const [dismissed, setDismissed] = useState(false);
    const [sent, setSent] = useState(false);

    if (!user || user.email_verified || dismissed) return null;

    const resend = async () => {
        try {
            await api.post("/auth/resend-verification", { email: user.email });
            setSent(true);
        } catch (e) {}
    };

    return (
        <div className="border-b-[3px] border-foreground bg-accent-soft" data-testid="verify-banner">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-3 text-sm">
                <span className="grid place-items-center w-7 h-7 rounded-lg border-2 border-foreground bg-accent text-accent-foreground shrink-0">
                    <MailWarning size={15} />
                </span>
                <p className="flex-1 leading-snug text-dim">
                    Please confirm your email to join the mailing list.{" "}
                    {sent ? (
                        <span className="font-bold bg-accent text-accent-foreground px-1" data-testid="verify-resent">
                            Confirmation link sent — check your inbox.
                        </span>
                    ) : (
                        <button
                            onClick={resend}
                            data-testid="verify-resend"
                            className="font-medium bg-accent text-accent-foreground px-1 link-underline"
                        >
                            Resend confirmation link
                        </button>
                    )}
                </p>
                <button
                    onClick={() => setDismissed(true)}
                    aria-label="Dismiss"
                    className="shrink-0 p-1 rounded-md text-dim hover:text-foreground transition-colors duration-150"
                >
                    <X size={15} />
                </button>
            </div>
        </div>
    );
}
